import locationParams from './utils/locationParams'

const langFromQueryString = () => {
  if (window.location.search.indexOf('widget-lang=en') > -1) return 'en';

  return 'ru';
}
class Widget {
  constructor() {
    this.showButtons = document.getElementsByClassName('marytrufel-preregistration');
    if (this.showButtons.length === 0) return

    this.rootNode = document.createElement('div');
    document.body.appendChild(this.rootNode);

    Array.from(this.showButtons).forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        const lang = button.dataset.preregistrationLang || langFromQueryString() || 'ru';
        const botFavoritesLink = button.dataset.botFavoritesLink;

        (async () => {
          const { render } = await import('./render.js');

          const close = () => {
            render(this.rootNode, { visible: false, lang });

            if (this.iframe) {
              document.documentElement.removeChild(this.iframe);
              this.iframe = null;
            }
          }
          close();

          const open = button => {
            const taxiRestriction = (button && button.dataset.taxiRestriction) || ''
            const taxiAvailable = (button && button.dataset.taxiAvailable === 'true') || false
            const preregistrationSuccessPromo = (button && button.dataset.preregistrationSuccessPromo) || ''
            const theme = (button && button.dataset.preregistrationColorTheme) || 'default'
            const phone = (button && button.dataset.phone) || ''
            const favoritesLink = button.dataset.favoritesLink
            const favoriteDressPhotos = button.dataset.favoriteDressPhotos
            const commentForSalesAssociate = button.dataset.commentForSalesAssociate

            render(this.rootNode, { visible: true, taxiRestriction, taxiAvailable, theme, preregistrationSuccessPromo, close, lang, botFavoritesLink, phone, favoritesLink, favoriteDressPhotos, commentForSalesAssociate });
          }

          setTimeout(() => {
            open(button);

            const integrationId = button.dataset.preregistrationIntegrationId;
            if (integrationId) {
              if (window.roistat && window.roistat.getVisit()) {
                this.sendIntegrationRequest(integrationId, window.roistat.getVisit(), lang);
              }
              else {
                const self = this;
                window.onRoistatAllModulesLoaded = function () {
                  window.roistat.registerOnVisitProcessedCallback(function() {
                    self.sendIntegrationRequest(integrationId, window.roistat.getVisit(), lang);
                  });
                };
              }
            }
          }, 0)

        })();
      });
    });
  }

  sendIntegrationRequest = (integrationId, roistatVisitId, locale) => {
    const url = locale === 'ru' ? `https://${integrationId}.yclients.com/?roistat_visit=${roistatVisitId}&roistat=${roistatVisitId}` : `https://${integrationId}.alteg.io/?roistat_visit=${roistatVisitId}&roistat=${roistatVisitId}`;

    var iframe = document.createElement('iframe');
    iframe.style = 'opacity: 0; width: 0; height: 0; overflow: hidden;'
    iframe.setAttribute('frameborder', 0);
    iframe.setAttribute('allowtransparency', 'true');
    iframe.src = url;

    this.iframe = iframe;
    document.documentElement.appendChild(this.iframe);
  }
}

const widget = new Widget();

function qsContainsAutoopenParam() {
  return locationParams().fitting === '1';
}

function qsWithoutAutoopenParam() {
  if (window.location.search === '?fitting=1') return '?';

  return window.location.search
    .replace('?fitting=1&', '?')
    .replace('&fitting=1', '');
}

function removeAutoopenParamFromQs() {
  if (!window.history || !window.history.replaceState) return;

  const newQueryString = qsWithoutAutoopenParam();
  window.history.replaceState({}, document.title, newQueryString);
}

if (qsContainsAutoopenParam()) {
  if (widget.showButtons && widget.showButtons.length > 0) widget.showButtons[0].click();
  removeAutoopenParamFromQs();
}



// WEBPACK FOOTER //
// ./src/index.js